var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.217 2.28184C12.4592 2.03952 12.852 2.03952 13.0942 2.28184L16.0185 5.20598C16.2608 5.4483 16.2608 5.84114 16.0185 6.08331L7.24553 14.8563C7.17754 14.9244 7.09446 14.9756 7.00307 15.0061L2.61677 16.4683C2.39384 16.5425 2.14805 16.4845 1.98205 16.3183C1.81589 16.1522 1.75787 15.9065 1.83209 15.6836L3.2943 11.297C3.32477 11.2056 3.376 11.1226 3.44413 11.0545L12.217 2.28184ZM12.6557 3.59769L11.4859 4.76746L13.5328 6.81442L14.7026 5.64465L12.6557 3.59769ZM12.6557 7.6919L10.6086 5.64479L4.76004 11.4933L6.807 13.5403L12.6557 7.6919ZM5.65864 14.1466L4.15392 12.6418L3.40147 14.899L5.65864 14.1466Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.53ba77de2f80919b6fd62abc2c1e990f.svg";
export { ForwardRef as ReactComponent };